import React, { useEffect } from "react";
import styles from "./formCategory.module.css";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import TextField from "component/textField/TextField";
import LabeledSelect from "component/select/labeledSelect/LabeledSelect";
import { useGetCities, useGetLGA, useGetStates } from "api/queries/dashboard/misc";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";

function EmergencyContact2({trigger, formData, application, setValue, watch, errors, register }) {
  const { states, loading } = useGetStates();
  const { LGA, setStateID } = useGetLGA();
  const { cities, setStateID: setStateIdForCities } = useGetCities();
  const state = watch("emergencyContact2State", "");

  useEffect(() => {
    const code = states?.find((_state)=>{
      return _state.name === state
    })?.state_code
    setStateID(code)
    setStateIdForCities(code)
  }, [state]);

  useEffect(() => {
    if (application.emergencyContact2State) {
      setValue('emergencyContact2State', application.emergencyContact2State)
      setStateID(
        states?.find((_state) => {
          return _state.name === application.emergencyContact2State;
        })?.state_code
      );
    }
  }, [states]);



  useEffect(() => {
    setValue("emergencyContact2Lga", application?.emergencyContact2Lga);
  }, [LGA]);

  useEffect(()=>{
    if(formData.emergencyContact2Phone){
      trigger('emergencyContact2Phone')
    }
  }, [formData.emergencyContact2Phone])

  return (
    <div className={styles.category_tab}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={4}>
          <div className={styles.category}>
            <Typography variant="h6">Emergency Contact (2) Details</Typography>
            <Typography>
              Please provide details of a contact that can be reached in the
              case of an emergency.
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} sm={8}>
          <div className={styles.category_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                 setValue={setValue}
                 watch={watch}
                   required={true}
                    name="emergencyContact2FirstName"
                    errors={errors}
                    register={register}
                    label="First Name"
                    type="text"
                    placeholder="First Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                     textValidation
                 setValue={setValue}
                 watch={watch}
                   required={true}
                    name="emergencyContact2LastName"
                    errors={errors}
                    register={register}
                    label="Last Name"
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={styles.field}>
                  <TextField
                   required={true}
                    name="emergencyContact2Address"
                    errors={errors}
                    register={register}
                    label="Address"
                    type="text"
                    placeholder="Insert Address"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                  register={register}
                  required={true}
                  data={states?.map((state) => {
                    return {
                      label: state.name,
                        value: state.name,
                    };
                  })}
                  errors={errors}
                    name="emergencyContact2State"
                    label="State"
                    placeholder="Select State"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    name="emergencyContact2Lga"
                    required={true}
                    data={LGA?.map((state) => {
                      return {
                        label: state,
                        value: state,
                      };
                    })}
                    errors={errors}
                    register={register}
                    label="LGA"
                    type="text"
                    placeholder="LGA"
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <LabeledSelect
                      required={true}
                      name="emergencyContact2City"
                      register={register}
                      errors={errors}
                      label="City"
                      data={cities}
                      placeholder="Select City"
                    />
                 
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                <PhoneNumberInput
                    value={formData.emergencyContact2Phone}
                    name="emergencyContact2Phone"
                    errors={errors}
                    setValue={setValue}
                  />
                  {/* <TextField
                   required={true}
                    name="emergencyContact2Phone"
                    errors={errors}
                    register={register}
                    label="Phone Number"
                    type="text"
                    placeholder="E.g +234 7849 9302"
                  /> */}
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                              name='emergencyContactOnePhoneNumber'
                  errors={errors}
                  register={register}
                    label="First Name"
                    type="text"
                    placeholder="First Name"
                  />
                </div>
              </Grid> */}
            </Grid>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default EmergencyContact2;